var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLeftArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.3333 18.3333H15.6833L21.1833 12.85C21.4972 12.5361 21.6735 12.1105 21.6735 11.6667C21.6735 11.2228 21.4972 10.7972 21.1833 10.4833C20.8695 10.1695 20.4438 9.99316 20 9.99316C19.5562 9.99316 19.1305 10.1695 18.8167 10.4833L10.4833 18.8167C10.3316 18.9752 10.2126 19.1621 10.1333 19.3667C9.96663 19.7724 9.96663 20.2275 10.1333 20.6333C10.2126 20.8379 10.3316 21.0248 10.4833 21.1833L18.8167 29.5166C18.9716 29.6729 19.1559 29.7969 19.359 29.8815C19.5621 29.9661 19.78 30.0096 20 30.0096C20.22 30.0096 20.4379 29.9661 20.641 29.8815C20.8441 29.7969 21.0284 29.6729 21.1833 29.5166C21.3395 29.3617 21.4635 29.1774 21.5481 28.9743C21.6328 28.7712 21.6763 28.5533 21.6763 28.3333C21.6763 28.1133 21.6328 27.8955 21.5481 27.6924C21.4635 27.4893 21.3395 27.3049 21.1833 27.15L15.6833 21.6667H28.3333C28.7754 21.6667 29.1993 21.4911 29.5118 21.1785C29.8244 20.8659 30 20.442 30 20C30 19.558 29.8244 19.134 29.5118 18.8215C29.1993 18.5089 28.7754 18.3333 28.3333 18.3333Z",
    fill: "#EB9F1A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/left_arrow.cb6da029a490c6db19d58cc3d8cb7d27.svg";
export { ForwardRef as ReactComponent };